import { m } from 'motion/react';
import { itemVariants, viewPort } from '../../../utils/framer';
import LinkButton from '../ui/LinkButton';

export interface Link {
  url: string;
  label: string;
  openInNewTab?: boolean;
  widthClass?: string;
}

interface TextBlockProps {
  title: string;
  text: string;
  links?: Link[];
  className?: string;
  titleClassName?: string;
  textClassName?: string;
  headingLevel?: 2 | 3;
}

const TextBlock: React.FC<TextBlockProps> = ({
  title,
  text,
  links,
  className = '',
  titleClassName = '',
  textClassName = '',
  headingLevel = 3,
}) => {
  const renderHeading = () => {
    switch (headingLevel) {
      case 2:
        return (
          <m.h2 className={titleClassName} variants={itemVariants}>
            {title}
          </m.h2>
        );
      case 3:
        return (
          <m.h3 className={titleClassName} variants={itemVariants}>
            {title}
          </m.h3>
        );
      default:
        return (
          <m.h3 className={titleClassName} variants={itemVariants}>
            {title}
          </m.h3>
        );
    }
  };
  return (
    <m.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
    >
      {renderHeading()}
      <m.p className={textClassName} variants={itemVariants}>
        {text}
      </m.p>
      {links && links.length > 0 && (
        <m.div className="mt-7 flex flex-col space-y-6" variants={itemVariants}>
          {links.map((link, index) => (
            <div
              key={link.url ?? index}
              className="flex justify-center md:justify-start"
            >
              <LinkButton
                url={link.url}
                text={link.label}
                openInNewTab={link.openInNewTab}
                widthClass={link.widthClass}
              />
            </div>
          ))}
        </m.div>
      )}
    </m.div>
  );
};

export default TextBlock;
